import { useState } from 'react';
import { EBetBuilderModalActions } from 'components/Generic/__partials/BetBuilderModalGeneric/actions';
import { BetBuilderModal } from 'newcomponents/Shared/sportsbook/BetBuilderModal';
import { TBetBuilderModalProps } from 'newcomponents/Shared/sportsbook/BetBuilderModal/types';
import { useEventbus } from 'newhooks/generic/useEventbus';

// @TODO need to move BetBuilder modal in generic instead of mounting for each game card

export const BetBuilderModalGeneric = () => {
  const [modalProps, setModalProps] = useState<TBetBuilderModalProps | null>(
    null
  );

  useEventbus({
    [EBetBuilderModalActions.OPEN_BET_BUILDER_MODAL]: ({
      payload
    }: {
      payload: TBetBuilderModalProps;
    }) => {
      setModalProps(payload);
    },

    [EBetBuilderModalActions.UPDATE_BET_BUILDER_MODAL_PROPS]: ({
      payload
    }: {
      payload: TBetBuilderModalProps;
    }) => {
      setModalProps(prevProps => ({ ...prevProps, ...payload }));
    },

    [EBetBuilderModalActions.CLOSE_BET_BUILDER_MODAL]: () => {
      setModalProps(null);
    }
  });

  return modalProps && <BetBuilderModal {...modalProps} />;
};
